import React from "react";
import axios from "axios";
import dayjs from 'dayjs';
import ConfigParser from '../../../js/common/utility/configParser';
import Element from '../../basic/element';
import Toggle from './components/toggle';
import Tabs from './components/tabs';
import Speaker from "./speaker";
import Day from './day';
import './index.scss';
import Courier from './courier';

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);

        const { config } = this.props;
        const parser = ConfigParser.toParser(config);

        const srcBaseUrl = this.getSrcBaseUrl(parser);
        const cfg = {
            agendaDataId: parser.parseString('agendaSheetId') || parser.parseString('agendaDataId'),
            speakerDataId: parser.parseString('speakerSheetId') || parser.parseString('speakerDataId'),
            registerUrl: parser.parseString('registerUrl', ''),
            apiUrl: parser.parseString('apiUrl', ''),
            apiBaseUrl: parser.parseString('apiBaseUrl', PubHub.APIHost + '/v1/bookmarks/types/'),
            agendaSrcUrl: parser.parseString('agendaSrcUrl', ''),
            speakerSrcUrl: parser.parseString('speakerSrcUrl', ''),
            srcBaseUrl: srcBaseUrl,
            props: ConfigParser.parseRoot(config, 'pubhub-agenda'),
            loginTitle: parser.parseString('> loginTitle', 'Log in to bookmark sessions and customize your agenda'),
            compact: parser.parseBool('compact'),
            title: parser.parseObject('> title', ''),
            eventName: parser.parseString('eventName') || parser.parseString('> title', ''),
            eventLink: parser.parseString('eventLink', window.location.href),
            subtitle: {
                unlogged: {
                    login: parser.parseString('> subtitle unlogged login', 'Log in'),
                    text: parser.parseString('> subtitle unlogged text', '${login} to bookmark sessions and customize your agenda.'),
                },
                logged: {
                    profile: parser.parseString('> subtitle logged profile', 'your profile'),
                    text: parser.parseString('> subtitle logged text', 'Bookmark sessions, create your agenda, and see it from ${profile}!'),
                }
            },
            dayFormat: parser.parseString('> dayFormat', 'MMM D, ddd'),
            dayUpperCase: parser.parseBool('> dayUpperCase', true),
            validDayFrom: parser.parseString('> validDayFrom', '2019-01-01'),
            expanded: parser.parseBool('expand', true),
            sectionWithTime: parser.parseBool('sectionWithTime', false),
            hideBookmarkFeature: parser.parseBool('hideBookmarks', false),
            removeSectionTimeWithoutTitle: parser.parseString('sectionDescriptionAlign', '') == 'left',
            switchViewByClickTitle: parser.parseBool('switchViewByClickTitle', false),
            embedVideo: parser.parseBool('embedVideo', false),
            session: {
                watch: parser.parseString('session watch', 'Watch video'),
                download: parser.parseString('session download', 'Download slides'),
                needSocialLoginIn: parser.parseString('session needSocialLoginIn', '')
            },
            agenda: {
                full: parser.parseString('toggle full', 'ALL'),
                my: parser.parseString('toggle my', 'BOOKMARKED'),
            },
            contentTypeColors: this.parseColors(config),
            myEmptyAgenda: {
                title: parser.parseObject('empty title', 'Looks like your agenda is empty now…'),
                description: parser.parseObject('empty description', 'Customize your own agenda by bookmarking sessions you are interested in!'),
                action: parser.parseString('empty action', 'See full agenda'),
                background: parser.parseString('empty background'),
            },
            book: {
                disabled: parser.parseBool('book disabled', false),
                saved: parser.parseString('book saved', 'SAVED'),
                removed: parser.parseString('book removed', 'REMOVED'),
                error: parser.parseString('book error', 'ERROR'),
            },
            speaker: {
                fullFormat: parser.parseBool('speaker fullFormat', true),
                connector: parser.parseString('speaker connector', ' | ', true),
                separator: parser.parseString('speaker separator', ',', true),
                avatarBaseUrl: parser.parseString('speaker avatarBaseUrl', 'images/agenda/speaker/')
            },
            errorMessage: {
                params: parser.parseObject('errorMessage params', 'Please make sure you provide agenda’s smart sheet id in the widget configuration.'),
                status: parser.parseObject('errorMessage status', this.getDefaultStatusErrorMessage()),
            },
            colors: this.readColors(config),
            registerMessage: parser.parseString('registerMessage', '', true),
        }

        this.state = {
            registerRetry: 0,
            config: cfg
        }
    }

    componentDidMount() {
          function scrollTo(height, duration = 600, offset = 0) {
            if (duration < 0) {
              return;
            }
          
            var duration = parseInt(duration);
            var offset = parseInt(offset);
          
            var windowHeight = window.pageYOffset !== undefined ? window.pageYOffset : window.scrollTop;
            var difference = height - windowHeight;
            var perTick = difference / duration * 10;
            var scrollToTimerCache = setTimeout(function () {
              if (!isNaN(parseInt(perTick, 10))) {
                window.scrollTo(0, window.scrollY + perTick);
                scrollTo(height, duration - 10, offset);
              }
            }.bind(this), 10);
            return scrollToTimerCache
          }
        const onLoad = () => { 
            console.log('onload....')
            setTimeout(() => {
                console.log('load..........')
                let videoLink = window.PubHub.util.cookie.getCookie("pubhub_agenda_video_link");
                let downloadLink = window.PubHub.util.cookie.getCookie("pubhub_agenda_download_link");
                console.log('videoLink.....', videoLink);
                console.log('downloadLink........', downloadLink);
                if(videoLink) {
                    // 跳转
                    console.log('has video link', );
                    videoLink = videoLink.split(' ')
                    let videoEle = document.querySelector(`[data-track-value="${videoLink[0]}"]`);
                    // window.PubHub.util.scrollTo(videoEle, 500, 200);
                    scrollTo(videoLink[1], 500, 0)
                    console.log('videoEle.....', videoEle)
                    setTimeout(() => {
                        videoEle && videoEle.click();
                    }, 800);
                    window.PubHub.util.cookie.deleteCookie("pubhub_agenda_video_link");
                }
                if(downloadLink) {
                    // 跳转
                    console.log('has download link')
                    downloadLink = downloadLink.split(' ')
                    let downloadEle = document.querySelector(`[data-track-value="${downloadLink[0]}"]`);
                    // window.PubHub.util.scrollTo(downloadEle, 500, 200);
                    scrollTo(downloadLink[1], 500, 0);
                    console.log('downloadEle.....', downloadEle);
                    setTimeout(() => {
                        downloadEle && downloadEle.click();
                    }, 800);
                    window.PubHub.util.cookie.deleteCookie("pubhub_agenda_download_link");
                }
            }, 1500);
        };
        if(document.readyState === "complete") onLoad();
        else addEventListener("load", onLoad);
    }

    render() {
        return (
            <AgendaComponent key={this.state.registerRetry} config={this.state.config} forceRefresh={this.forceRefresh} />
        );
    }

    readColors(config) {
        return Array.from(config.querySelectorAll('contentTypeColors > color')).map(
            (i) => {
                const key = i.dataset.key;
                var value = i.textContent.trim();
                return key ? { key, value } : { value }
            }
        );
    }

    parseColors(config) {
        return Array.from(config.querySelectorAll('contentTypeColors > color')).map(
            (i, index) => {
                const key = i.dataset.key || index;
                return { key: key, val: i.textContent.trim() }
            }
        ).reduce((r, i) => {
            r[i.key] = i.val;
            return r;
        }, {});
    }

    getDefaultStatusErrorMessage() {
        return `<div>
            <p>1. Make you have already created smartsheets and the sheet ids are valid.</p>
            <p>2. Make sure you share both smartsheets with Haihua(haihxiao@cisco.com)</p>
            <p>3. If problem still exists, please contact UX & Apps team.</p>
        </div>`;
    }

    getSrcBaseUrl(parser) {
        let srcBaseUrl = PubHub.env == "production" ? 'https://sheets.production.devnetcloud.com/agenda' : 'https://sheets.testing.devnetcloud.com/agenda'
        srcBaseUrl = parser.parseString('srcBaseUrl', srcBaseUrl);
        return srcBaseUrl.endsWith('/') ? srcBaseUrl : srcBaseUrl + '/';
    }

    forceRefresh = () => {
        const { registerRetry } = this.state;
        if (registerRetry < 1) {
            this.setState({ registerRetry: registerRetry + 1 });
        }
    }
}

class AgendaComponent extends React.Component {
    constructor(props) {
        super(props);

        const { agendaSrcUrl, agendaDataId, compact, errorMessage, hideBookmarkFeature } = this.props.config;

        this.state = {
            dayIndex: 0,
            compact: compact,
            hideBookmarks: hideBookmarkFeature,
            showMyAgenda: false,
            speaker: null,
            data: null,
            errorMessage: agendaSrcUrl || agendaDataId ? undefined : errorMessage.params,
            loadingMyAgenda: true,
            speakers: {}
        }
    }

    componentDidMount() {
        if (!this.state.errorMessage) {
            this.resumeFetchMyAgenda();
            this.fetchFullAgenda();
        }
    }

    render() {
        const { props, title, subtitle, switchViewByClickTitle, book } = this.props.config;
        const hasErr = this.state.errorMessage;
        const errorMessage = hasErr && this.renderErrorMessage(this.state.errorMessage);
        const toggleRow = !hasErr && !this.state.compact && !this.state.hideBookmarks && this.state.data && this.renderToggle(subtitle);
        const content = !hasErr && this.renderContent(this.state.data);
        const speakerModal = this.state.speaker ? <Speaker data={this.state.speaker} onClose={this.onCloseSpeaker} /> : null;
        const className = props.className + ((book || {}).disabled ? " book-disabled" : "");

        return (
            <div {...props} className={className}>
                <div className='header' onClick={this.onClickTitle}>
                    <div className='container'>
                        <Element className={'title' + (switchViewByClickTitle ? ' clickable' : '')} data={title} />
                    </div>
                </div>
                {toggleRow}
                {errorMessage}
                {content}
                {speakerModal}
            </div>
        );
    }

    renderErrorMessage(errorMessage) {
        return (
            <div className='error-container'>
                <div className='err-msg-area'>
                    <div className='err-msg-content'>
                        <Element className='err-msg' data={errorMessage} />
                    </div>
                </div>
            </div>
        );
    }

    renderToggle(subtitle) {
        const { full, my } = this.props.config.agenda;
        const desc = this.renderSubtitle(subtitle);
        return (
            <div className='toggle-container'>
                <div className='container'>
                    <div className='toggle-row'>
                        <Toggle left={full} right={my} active={this.state.showMyAgenda} onChange={this.onChangeSwitch} />
                        <div className='desc'>
                            <i className="fas fa-star"></i>
                            <div className='desc-text'>{desc}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSubtitle(subtitle) {
        const isLoggedIn = PlatformSDK.isLoggedIn();
        const variable = isLoggedIn ? '${profile}' : '${login}';
        const schema = isLoggedIn ? subtitle.logged.text : subtitle.unlogged.text;
        const index = schema.indexOf(variable);
        if (index == -1) {
            return (
                <div className='desc-subtitle'>
                    {schema}
                </div>
            );
        }

        const preString = schema.substr(0, index);
        const nextString = schema.substring(index + variable.length);
        const prePart = preString && <span>{preString}</span>;
        const nextPart = nextString && <span>{nextString}</span>
        const link = isLoggedIn ? (
            <a className='subtitle-link' href='/user/dashboard#event' target='_blank' rel="noopener noreferrer">{subtitle.logged.profile}</a>
        ) : (
            <span className='subtitle-link' onClick={this.onClickSubtitleLogin}>{subtitle.unlogged.login}</span>
        );
        return (
            <div className='desc-subtitle'>
                {prePart}
                {link}
                {nextPart}
            </div>
        );
    }

    renderContent(data) {
        if (!data) {
            return <div className='loading-container'><div className='pubhub-loading'></div></div>
        }

        const dayTabs = this.renderDayTabs(data);
        const daysOfFullAgenda = this.renderDays(data, false);
        const daysOfMyAgenda = this.renderDays(data, true);
        return (
            <div className='body-container'>
                <div className='container'>
                    <div className='body'>
                        <Tabs index={this.state.dayIndex} onChange={this.onChangeDayIndex}>{dayTabs}</Tabs>
                        <div className={'days full-agenda' + (this.state.showMyAgenda ? '' : ' active')}>
                            {daysOfFullAgenda}
                        </div>
                        <div className={'days my-agenda' + (this.state.showMyAgenda ? ' active' : '')}>
                            {daysOfMyAgenda}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDayTabs(data) {
        return data.map(i =>
            i.day ? (
                <div className={'day-title' + this.getDayTitleClassName()} key={i.day}>
                    {this.formatDay(i.day)}
                </div>
            ) : null
        );
    }

    renderDays(data, myAgenda) {
        const { dayIndex, loadingMyAgenda, compact, hideBookmarks } = this.state;
        const { config } = this.props;
        return data.map((i, index) =>
            <Day key={i.day}
                titleClassName={this.getDayTitleClassName()}
                day={this.formatDay(i.day)}
                myAgendaLoaded={!loadingMyAgenda}
                bookedView={myAgenda}
                compact={compact}
                hideBookmarks={hideBookmarks}
                expandedDefault={config.expanded}
                sectionWithTime={config.sectionWithTime}
                removeSectionTimeWithoutTitle={config.removeSectionTimeWithoutTitle}
                embedVideo={config.embedVideo}
                session={config.session}
                speakerFormat={config.speaker}
                myEmptyAgenda={config.myEmptyAgenda}
                book={config.book}
                data={i}
                onBeforeUpdateBookmark={this.onBeforeUpdateBookmark}
                onUpdateBookmark={this.onUpdateBookmark}
                onClickSpeaker={this.onOpenSpeaker}
                onGotoFullAgenda={this.onGotoFullAgenda}
                className={index == dayIndex ? ' active' : ''}
            />
        )
    }

    formatDay(day) {
        const { dayFormat, validDayFrom } = this.props.config;
        if (!dayFormat) return day;

        try {
            const date = dayjs(day);
            return date.isValid() && date.format('YYYY-MM-DD') >= validDayFrom ? date.format(dayFormat) : day;
        } catch (err) {
            return day;
        }
    }

    getDayTitleClassName() {
        return this.props.config.dayUpperCase ? ' uppercase-day-title' : '';
    }

    resumeBookSession(data) {
        if (this.sessionToBook) {
            for (let day of data) {
                for (let section of day.sections) {
                    for (let session of section.sessions) {
                        if (session.id == this.sessionToBook.id) {
                            this.updateBookmark(session.id, !this.sessionToBook.book, (err) => {
                                if (!err) {
                                    session.booked = this.sessionToBook.book;
                                    this.setState({ data: this.state.data });
                                }
                            });
                            return;
                        }
                    }
                }
            }
        }
    }

    onClickTitle = () => {
        if (this.props.config.switchViewByClickTitle) {
            this.setState({ compact: !this.state.compact });
        }
    }

    onChangeDayIndex = (e) => {
        this.setState({ dayIndex: e.target.value });
    }

    onChangeSwitch = (active) => {
        if (active) {
            const logged = PlatformSDK.openProtectedData("to-my-agenda", this.props.config.loginTitle);
            if (logged) {
                this.setState({ showMyAgenda: active });
                this.fetchMyAgenda();
            }
        } else {
            this.setState({ showMyAgenda: active });
        }
    }

    onGotoFullAgenda = () => {
        this.setState({ showMyAgenda: false });
    }

    onBeforeUpdateBookmark = (data) => {
        const cookie = {
            id: data.id,
            title: data.title,
            book: data.book,
        }

        return PlatformSDK.openProtectedData(JSON.stringify(cookie), this.props.config.loginTitle);
    }

    onUpdateBookmark = (data, callback) => {
        this.updateBookmark(data.id, !data.booked, callback);
    }

    onOpenSpeaker = (id) => {
        const speaker = this.state.speakers[id];
        if (speaker && !speaker.noDetail) {
            this.setState({ speaker });
        }
    }

    onCloseSpeaker = () => {
        this.setState({ speaker: null });
    }

    onClickSubtitleLogin = () => {
        PlatformSDK.openLogin(this.props.config.loginTitle);
    }

    appendColorForSections(data) {
        data.forEach(day =>
            day.sections.forEach((section, index) => {
                const { contentTypeColors } = this.props.config;
                section.color = contentTypeColors[section.title] || contentTypeColors[index];
            })
        );
    }

    appendSpearkers(data, speakers) {
        const dict = (speakers || []).reduce((r, i) => {
            const id = i.fullName || '';
            const fullName = this.buildSpeakerFullName(i);
            r[id] = { ...i, ...{ fullName }, id: id }
            return r;
        }, {});

        this.setState({ speakers: dict });

        data.forEach(day =>
            day.sections.forEach(section =>
                section.sessions.forEach(session => {
                    for (let i in session.speakers) {
                        let speaker = dict[session.speakers[i]];
                        if (speaker) {
                            speaker.noDetail = !((speaker.biography || '').trim());
                        }
                        session.speakers[i] = speaker || { id: session.speakers[i], fullName: this.speakerIdToFullName(session.speakers[i]), noDetail: true };
                    }
                })
            )
        );
    }

    speakerIdToFullName(id) {
        const pIdx = id.indexOf('#');
        return pIdx == -1 ? id : id.substr(0, pIdx);
    }

    buildSpeakerFullName(data) {
        return this.speakerIdToFullName(data.fullName || '');
    }

    handleSessions(data) {
        data.forEach(day => {
            day.sections.forEach(sec => {
                sec.sessions.forEach(session => {
                    session.id = session.bookmarkId || session.sessionId || session.id;
                })
            })
        });
    }

    buildApiUrl() {
        const { apiUrl, apiBaseUrl, agendaDataId } = this.props.config;
        return apiUrl || `${apiBaseUrl}${agendaDataId}_agendawidget`
    }

    buildAgendaSrcUrl(config) {
        return config.agendaSrcUrl || `${config.srcBaseUrl}${config.agendaDataId}/data.json`;
    }

    buildSpeakerSrcUrl(config) {
        if (config.speakerSrcUrl) return config.speakerSrcUrl;

        return config.speakerDataId ? `${config.srcBaseUrl}${config.speakerDataId}/data.json` : '';
    }

    fetchFullAgenda() {
        const { config } = this.props;
        const agendaUrl = this.buildAgendaSrcUrl(config);
        const speakerUrl = this.buildSpeakerSrcUrl(config);
        this._courier = new Courier();
        this._courier.fetch([agendaUrl, speakerUrl], (results) => {
            const agendaError = results[agendaUrl] ? results[agendaUrl].error : undefined;
            const speakerError = results[speakerUrl] ? results[speakerUrl].error : undefined;

            if (agendaError || speakerError) {
                this.setState({ errorMessage: this.getRegisterInfo() });
                this.registerJsonData(agendaError ? config.agendaDataId : undefined
                    , speakerError ? config.speakerDataId : undefined);
            } else {
                const agendaData = (results[agendaUrl] && results[agendaUrl].response) ? results[agendaUrl].response.data : undefined;
                const speakerData = (results[speakerUrl] && results[speakerUrl].response) ? results[speakerUrl].response.data : undefined;
                this.fullAgendaFetched(agendaData, speakerData);
            }
        });
    }

    fullAgendaFetched = (agendaData, speakerData) => {
        this.handleSessions(agendaData);
        this.appendColorForSections(agendaData);
        this.appendSpearkers(agendaData, speakerData);

        this.resumeBookSession(agendaData);

        this.setState({ data: agendaData });
        this.fullAgendaData = agendaData;
        this.mergeAgendaData(this.fullAgendaData, this.myAgendaData);
    }

    resumeFetchMyAgenda() {
        if (PlatformSDK.isLoggedIn()) {
            this.fetchMyAgenda();
        }

        PlatformSDK.resumeProtectedData((data) => {
            if (data == 'to-my-agenda') {
                this.setState({ showMyAgenda: true });
            }

            this.sessionToBook = data;
        });
    }

    fetchMyAgenda() {
        this.setState({ loadingMyAgenda: true });
        const apiUrl = this.buildApiUrl();
        axios.get(apiUrl, { withCredentials: true }).then((response) => {
            this.myAgendaData = response.data;
            this.setState({ loadingMyAgenda: false });
            this.mergeAgendaData(this.fullAgendaData, this.myAgendaData);
        });
    }

    mergeAgendaData(fullAgendaData, myAgendaData) {
        if ((!fullAgendaData) || (!myAgendaData) || (myAgendaData.length == 0)) return;
        const dict = myAgendaData[0].bmmap;

        fullAgendaData.forEach(day => {
            day.sections.forEach(sec => {
                sec.sessions.forEach(session => {
                    if (dict[session.id]) {
                        session.booked = true;
                    }
                })
            })
        });

        this.setState({});
    }

    updateBookmark(id, deleting, callback) {
        const days = this.state.data ? this.state.data.map(i => i.day) : [];
        const eventStartDate = days.length ? days[0] : '';
        const eventEndDate = days.length ? days[days.length - 1] : '';
        const { eventName, eventLink, agendaDataId = '', speakerDataId = '' } = this.props.config;
        const baseMetadata = {
            eventName,
            eventStartDate,
            eventEndDate,
            eventLink,
            agendaDataId,
            speakerDataId,
            sessionId: id
        };

        const colors = this.props.config.colors.length != 0 ? this.props.config.colors : undefined;
        const metadata = colors ? { ...baseMetadata, contentTypeColors: JSON.stringify(colors) } : baseMetadata;

        const data = {
            bmmap: {
                [id]: {
                    metadata: metadata
                }
            }
        };

        const apiUrl = this.buildApiUrl() + (deleting ? "?action=delete" : '');
        axios.put(apiUrl, data, { withCredentials: true, crossDomain: true }).then(() => {
            callback && callback();
        }).catch((err) => {
            callback(err);
        });
    }

    getRegisterInfo() {
        const { registerMessage } = this.props.config;
        return registerMessage || `Initializing data ...`;
    }

    registerJsonData(agendaId, speakerId) {
        const data = { agendaId, speakerId };
        axios.post(this.buildRegisterUrl(), data)
            .then(() => {
                setTimeout(() => {
                    this.props.forceRefresh && this.props.forceRefresh();
                }, 3000);
            })
            .catch(error => {
                this.setState({
                    errorMessage: this.props.config.errorMessage.status
                });
            })
    }

    buildRegisterUrl() {
        if (this.props.config.registerUrl) return this.props.config.registerUrl;

        return PubHub.APIHost + "/v1/agendawidget/agendas/register";
    }
}
